import React, { useState } from 'react';
import Layout from '../components/Layout';
import PageHeader from '../components/PageHeader';
import SectionHeader from '../components/SectionHeader';
import ProjectCard from '../components/cards/ProjectCard';
import ProjectModal from '../components/ProjectModal';
import { Button } from '../components/ui/button';

const Projects = () => {
  const [filter, setFilter] = useState('All');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      title: "ACPP-II JSPL Angul",
      client: "Jindal Steel & Power Ltd",
      location: "Angul, Odisha",
      status: "Ongoing",
      value: "₹135 Cr",
      category: "Power Plants",
      image: "https://images.unsplash.com/photo-1761414500570-0b835cdcf3c8?q=80&w=2070&auto=format&fit=crop"
    },
    {
      title: "JSPL Steel Plant SMS2",
      client: "Jindal Steel & Power Ltd",
      location: "Angul, Odisha",
      status: "Ongoing",
      value: "₹55 Cr",
      category: "Steel Plants",
      image: "https://images.unsplash.com/photo-1624027492684-327af1fb7559?q=80&w=2070&auto=format&fit=crop"
    },
    {
      title: "Vertical Unifier Tower",
      client: "L&T Construction",
      location: "Palava, Mumbai",
      status: "Completed",
      value: "₹180 Cr",
      category: "Real Estate",
      image: "https://images.unsplash.com/photo-1649617413676-28b74f1ac4d3?q=80&w=2070&auto=format&fit=crop"
    },
    {
      title: "Pune Metro Corridor-2",
      client: "MahaMetro",
      location: "Pune, Maharashtra",
      status: "Ongoing",
      value: "₹85 Cr",
      category: "Metro",
      image: "https://images.unsplash.com/photo-1687580712205-8f15015e1776?q=80&w=2070&auto=format&fit=crop"
    },
    {
      title: "NESCL RSP",
      client: "Rourkela Steel Plant",
      location: "Rourkela",
      status: "Completed",
      value: "₹40 Cr",
      category: "Steel Plants",
      image: "https://images.unsplash.com/photo-1517089596392-fb9a9033e05b?q=80&w=2070&auto=format&fit=crop"
    },
    {
      title: "TRIPTI ESTIA",
      client: "Rustomjee",
      location: "Mumbai",
      status: "Ongoing",
      value: "₹70 Cr",
      category: "Real Estate",
      image: "https://images.unsplash.com/photo-1540760029765-138c8f6d2eac?q=80&w=2070&auto=format&fit=crop"
    },
    {
      title: "Solar Installation",
      client: "Various Clients",
      location: "Multiple Locations",
      status: "Ongoing",
      value: "₹50 Cr",
      category: "Solar",
      image: "/assets/image (1).jpg",
      images: [
        "/assets/image (1).jpg",
        "/assets/image (2).jpg",
        "/assets/image (3).jpg",
        "/assets/image (4).jpg",
        "/assets/image (5).jpg",
        "/assets/image (6).jpg",
        "/assets/image (7).jpg",
        "/assets/image (8).jpg",
        "/assets/image (9).jpg",
        "/assets/image (10).jpg",
        "/assets/image (11).jpg",
        "/assets/image (12).jpg"
      ]
    }
  ];

  const categories = ['All', 'Steel Plants', 'Power Plants', 'Metro', 'Real Estate', 'Solar'];

  const filteredProjects = filter === 'All'
    ? projects
    : projects.filter(p => p.category === filter);

  return (
    <Layout>
      <PageHeader
        title="Our Projects"
        subtitle="Proven Track Record Across Sectors"
        image="https://images.unsplash.com/photo-1722544133021-68bd0de62e95?q=80&w=2070&auto=format&fit=crop"
      />

      <section className="py-24 bg-background">
        <div className="container mx-auto px-4">
          {/* Filter Tabs */}
          <div className="flex flex-wrap justify-center gap-4 mb-16" data-aos="fade-up">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setFilter(cat)}
                className={`px-6 py-2 rounded-full text-sm font-bold tracking-wider transition-all duration-300 ${
                  filter === cat
                    ? 'bg-primary text-background shadow-[0_0_20px_rgba(212,175,55,0.4)]'
                    : 'bg-card border border-white/10 text-muted-foreground hover:border-primary hover:text-primary'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Projects Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProjects.map((project, index) => (
              <ProjectCard
                key={index}
                {...project}
                onView={project.images ? () => {
                  setSelectedProject(project);
                  setIsModalOpen(true);
                } : undefined}
              />
            ))}
          </div>
        </div>
      </section>

      {selectedProject && (
        <ProjectModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title={selectedProject.title}
          images={selectedProject.images}
        />
      )}
    </Layout>
  );
};

export default Projects;
